import { useContext } from 'react';
import { Navigate } from 'react-router';

import { Loading } from '../loading.tsx';
import { AuthContext } from '../context/auth-context.tsx';
import { ROUTES } from '@/constants/routes';

export const InviteMemberRoute = () => {
  const { user, loading, isValidating } = useContext(AuthContext);

  if (loading || isValidating) return <Loading />;
  if (!user) return <Navigate to={ROUTES.LOGIN} replace />;

  return <Navigate to='/' replace />;
};
